import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { BillingType, InitialDiscount } from '~/components/BillModal/BillClientModal.types';
import { LineItemType } from '~/models/invoice-draft';
const SCHEDULED_LINE_ITEM_PLACEHOLDER = 'scheduled-invoice-line-item';
const toDiscountValue = (discount)=>discount == null ? InitialDiscount : {
        type: discount.type(),
        amount: discount.amount().toString()
    };
const chargeFields = (lineItem)=>{
    switch(lineItem.source){
        case LineItemType.AdHocCharge:
            return {
                quantity: lineItem.adHocCharge.quantity.toString(),
                rate: lineItem.rate.amount.toString(),
                discount: toDiscountValue(lineItem.adHocCharge.discount)
            };
        case LineItemType.Manual:
            return lineItem.manual.quantity != null ? {
                quantity: lineItem.manual.quantity.toString(),
                rate: lineItem.rate.amount.toString(),
                discount: toDiscountValue(lineItem.manual.discount)
            } : {
                quantity: '1',
                rate: lineItem.totalAmount.toString(),
                discount: InitialDiscount
            };
        case LineItemType.Automatic:
        case LineItemType.Credit:
            return {
                quantity: '1',
                rate: lineItem.totalAmount.toString(),
                discount: InitialDiscount
            };
    }
};
export const scheduledInvoiceDisabledItem = (lineItem)=>{
    var _lineItem_note;
    return {
        itemId: lineItem.id,
        type: BillingType.Charge,
        name: lineItem.name,
        note: (_lineItem_note = lineItem.note) !== null && _lineItem_note !== void 0 ? _lineItem_note : '',
        disabled: true,
        charge: _object_spread({
            serviceTemplateId: SCHEDULED_LINE_ITEM_PLACEHOLDER
        }, chargeFields(lineItem))
    };
};
export const scheduledInvoiceDisabledItems = (lineItems)=>lineItems.map(scheduledInvoiceDisabledItem);
